import { createConsoleLogHandler, createStructuredLogger } from "@project-x/api-clients";

const isBrowserProd = typeof window !== "undefined" && process.env.NODE_ENV === "production";

export const appLogger = createStructuredLogger(
  ...(isBrowserProd ? [] : [createConsoleLogHandler({ namespace: "consumer-site" })])
);
